import { TranslatePipe } from "@ngx-translate/core";

import { DecimalPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnChanges, SimpleChanges, computed, input } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";

import {
  WirelessHealthStatus,
  WirelessKpiAerohive,
  WirelessKpiAruba,
} from "../../../apis/networkdashboard/rest/models";
import { KPI_ITEMS_AEROHIVE, KPI_ITEMS_ARUBA, KpiItem, getStatusColor } from "../../../helpers/kpi/kpi-item";

@Component({
  selector: "kpi-row",
  templateUrl: "kpi-row.html",
  styleUrls: ["kpi-row.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DecimalPipe, MatTooltipModule, TranslatePipe],
})
export class KpiRowComponent implements OnChanges {
  protected healthData = input.required<WirelessHealthStatus>();
  protected vendor = input.required<string>();

  protected kpiAverages = computed(() => this.healthData().kpiAverages);
  protected kpiValues: { value: number; item: KpiItem }[] = [];

  statusColor = getStatusColor;

  ngOnChanges(changes: SimpleChanges) {
    if (changes["healthData"]) {
      if (this.healthData() && this.kpiAverages()) {
        this.updateKpiAverages(this.kpiAverages());
      }
    }
  }

  updateKpiAverages(kpiAverages: WirelessKpiAerohive | WirelessKpiAruba) {
    this.kpiValues = this.getKpiItems().map((kpiItem) => {
      const multiplier = kpiItem.multiplier ?? 1;
      const value = parseFloat(kpiAverages[kpiItem.key]) * multiplier;
      return { value, item: kpiItem };
    });
  }

  getKpiItems(): KpiItem[] {
    const vendor = this.vendor()?.toLowerCase()?.trim()?.replace(" ", "-");
    if (vendor === "aerohive") {
      return KPI_ITEMS_AEROHIVE;
    } else if (vendor === "aruba") {
      return KPI_ITEMS_ARUBA;
    } else {
      console.warn(`Unknown wifi vendor: ${vendor}.`);
      return [];
    }
  }
}
